import { rootApi } from "../../api/rootApi";

export const couponProviderApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllCouponProvider: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/couponProvider?type=${params.type}&limit=${params.limit}&offset=${params.offset}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    
    addCouponProvider: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/couponProvider/add`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    updateCouponProvider: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/couponProvider/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    deleteCouponProvider: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/tenant/couponProvider/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
  }),
});

export const {
  useFetchAllCouponProviderMutation , useAddCouponProviderMutation , useDeleteCouponProviderMutation , useUpdateCouponProviderMutation 
} = couponProviderApi;
